import React, {useState} from "react";
import {Button, Col, Form, Input, notification, Radio, Row} from "antd";
import {ApartmentOutlined, HomeOutlined} from '@ant-design/icons';
import {register} from "../../util/APIUtils";
import {useHistory} from "react-router-dom";
import {showAxiosError} from "../../util/Helpers";
import {resourcePrefixType} from "../../util/Enums";
import {PASSWORD_ERROR_MESSAGE, PASSWORD_REGEX, VirtualHost} from "../../constants";

function SignUpForm() {
    let history = useHistory();
    const [activityArea, setActivityArea] = useState(false);
    const [signUpRequestSend, setSignUpRequestSend] = useState(false)
    const [showCallCenterNumber, setShowCallCenterNumber] = useState(false);

    function signUp(values) {
        setSignUpRequestSend(true);

        if (resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix) {
            if (values.activityArea === "other") {
                values.activityArea = values.activityArea2;
            }
        } else if (resourcePrefixType.optikkart === VirtualHost.resourcePrefix) {
            values.activityArea = "optikkart";
        }

        register(JSON.stringify(values)).then((response) => {
            setSignUpRequestSend(false);
            notification.success({
                message: "Başarılı",
                description: "Başarılı bir şekilde kayıt oldunuz",
            });
            history.push("/login");
        }).catch((error) => {
            setSignUpRequestSend(false);
            showAxiosError(error.response)
        });
    }

    function onFinishFailed(values) {
        setShowCallCenterNumber(true);
    }

    function handleKeyPress(event) {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    }

    return (
        <Form layout="vertical" className="sign-up-form" onFinish={signUp} onFinishFailed={onFinishFailed}>
            <Row>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Adınız"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen adınızı giriniz.",
                            },
                        ]}
                    >
                        <Input className="sign-up-form-input" name="name" size="large"/>
                    </Form.Item>

                </Col>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Soyadınız"
                        name="surname"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen soyadınızı giriniz.",
                            },
                        ]}
                    >
                        <Input className="sign-up-form-input" name="surname" size="large"/>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                max: 50,
                                message: "Lütfen email adresinizi giriniz.",
                            },
                        ]}
                    >
                        <Input className="sign-up-form-input" name="email" size="large"/>
                    </Form.Item>

                </Col>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Email Onayla"
                        name="confirmEmail"
                        dependencies={["email"]}
                        hasFeedback
                        rules={[
                            {
                                type: "email",
                                required: true,
                                max: 50,
                                message: "Lütfen email adresinizi giriniz.",
                            },
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("email") === value) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject(new Error("Email Adresiniz Eşleşmiyor."));
                                },
                            }),
                        ]}
                    >
                        <Input className="sign-up-form-input" name="email" size="large"/>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Şifre"
                        name="password"
                        rules={[
                            {
                                required: true,
                                min: 8,
                                message: "Lütfen şifrenizi giriniz.",
                            },
                            () => ({
                                validator(_, value) {
                                    if (PASSWORD_REGEX.test(value)) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject(
                                        new Error(
                                            PASSWORD_ERROR_MESSAGE
                                        )
                                    );
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            className="sign-up-form-input"
                            name="password"
                            size="large"
                        />
                    </Form.Item>
                </Col>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        name="confirmPassword"
                        label="Şifre Onayla"
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: "Lütfen şifrenizi doğrulayınız.",
                            },
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("password") === value) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject(new Error("Şifreniz eşleşmiyor."));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            className="sign-up-form-input"
                            name="confirmPassword"
                            size="large"
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="TC Kimlik Numaranız"
                        name="tckn"
                        rules={[
                            {
                                required: true,
                                min: 11,
                                max: 11,
                                message: "Lütfen TC kimlik numaranızı giriniz.",
                            },
                            {
                                pattern: /^[0-9]{11}$/,
                                message: "TC kimlik numarası 11 rakamdan oluşmalıdır.",
                            },
                        ]}
                    >
                        <Input onKeyPress={handleKeyPress} className="sign-up-form-input" name="tckn" size="large" maxLength={11}/>
                    </Form.Item>
                </Col>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Telefon Numaranız"
                        name="phoneNumber"
                        rules={[
                            {
                                required: true,
                                min: 10,
                                max: 10,
                                message: "Lütfen telefon numaranızı giriniz. (5XXXXXXXXX).",
                            },
                        ]}
                    >
                        <Input onKeyPress={handleKeyPress} className="sign-up-form-input" name="phoneNumber" placeholder="5XXXXXXXXX" size="large" maxLength={10}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="İş Adresiniz"
                        name="workAddress"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen iş adresinizi giriniz.",
                            },
                        ]}
                    >
                        <Input prefix={<ApartmentOutlined/>} className="sign-up-form-input" size="large"/>
                    </Form.Item>
                </Col>
                <Col span={11} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label=" Ev Adresiniz"
                        name="homeAddress"
                        rules={[
                            {
                                required: false,
                                message: "Lütfen ev adresinizi giriniz.",
                            },
                        ]}
                    >
                        <Input prefix={<HomeOutlined/>} className="sign-up-form-input" size="large"/>
                    </Form.Item>
                </Col>
            </Row>

            {resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix &&
                <Row>
                    <Col span={11} style={{
                        margin: '0 8px',
                    }}>
                        <Form.Item name="activityArea" label="Çalışma Alanı">
                            <Radio.Group name="activityArea1">
                                <Radio
                                    name="eczaneEczaci"
                                    onClick={() => {
                                        setActivityArea(false);
                                    }}
                                    value="eczaneEczaci"
                                >
                                    Eczane Eczacı
                                </Radio>
                                <Radio
                                    name="kamuEczaci"
                                    onClick={() => {
                                        setActivityArea(false);
                                    }}
                                    value="kamuEczaci"
                                >
                                    Kamu Eczacı
                                </Radio>
                                <Radio
                                    name="ozelSektorEczaci"
                                    onClick={() => {
                                        setActivityArea(false);
                                    }}
                                    value="ozelSektorEczaci"
                                >
                                    Özel Sektör Eczacı
                                </Radio>
                                <Radio
                                    name="other"
                                    onClick={() => {
                                        setActivityArea(true);
                                    }}
                                    value="other"
                                >
                                    Diğer
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={11} style={{
                        margin: '0 8px',
                    }}>
                        <Form.Item name="activityArea2" label="&nbsp;" hidden={!activityArea}>
                            <Radio.Group>
                                <Radio name="student" value="student">
                                    Öğrenci
                                </Radio>
                                <Radio name="retired" value="retired">
                                    Emekli
                                </Radio>
                                <Radio name="unemployed" value="unemployed">
                                    Çalışmayan
                                </Radio>
                                  <Radio name="assistantPharmacist" value="assistantPharmacist">
                                    Yardimci Eczaci
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>}

            {showCallCenterNumber &&
                <Row>
                    <Col span={24} style={{
                        margin: '0 8px 18px',
                    }}>
                        <label>Üyelik ilgili sorun yaşıyorsanız <b>0312 911 5252</b> nolu çağrı merkezimizle iletişime
                            geçebilirsiniz.</label>
                    </Col>
                </Row>}

            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    className="sign-up-submit-btn d-flex align-center justify-center"
                    name="submit"
                    disabled={signUpRequestSend}
                >
                    <p>Kayıt Ol</p>
                </Button>
            </Form.Item>
        </Form>
    );
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/component/SignUpForm/index.js